import styles from "./style.module.css";
import okkologo from "../../assets/okkologo.svg";

const Logo = ({ children, className, ...props }) => {
  return (
    <img
      src={okkologo}
      className={[styles.logo, className].join(" ")}
      {...props}
    >
      {children}
    </img>
  );
};

export default Logo;
